import React, { Component } from 'react';
import config from 'config/config';
// import Modal from 'utils/components/modal'
// import VideoTutorialModal from '../../modals/video-tutorial';

class ConversationSetupFAQ extends Component {
  openVideoModal() {
    this.refs.videoTutorialModal.show();
  }

  closeModal() {
    this.refs.videoTutorialModal.hide();
  }

  render() {
    return (
      <div className="faqs">
        {/*<div className="faq">Watch the tutorial</div>
                <div className="video-section">
                    <div className="image-wrapper" onClick={ this.openVideoModal.bind(this) }>
                        <img src='https://publisher-assets.spot.im/host-panel/integration.jpg' />
                        <div className="circle"></div>
                        <Icon name="play-video" className="play-icon"/>
                    </div>
                    <div className="description">
                    See our video guide for more on how to implement your code.
                    <a href="https://www.youtube.com/channel/UCdkJxU-BHq1RQ8HN0asa0cg" target="_blank" className="link">
                        More tutorials
                    </a>
                    </div>
                </div> */}
        <div className="faq">Have questions?</div>
        <div className="faq-description">
          <span>
            Visit our
            <a className="faq-link" href={config.api.urls.support} target="_blank">
              {' '}
              support{' '}
            </a>
            site or go ahead and
            <a className="faq-link" href={config.api.urls.contact} target="_blank">
              {' '}
              contact{' '}
            </a>
            our support team.
          </span>
        </div>
      </div>
    );
  }
}

export default ConversationSetupFAQ;
